<template>
  <div class="content">

    <div class="flex flex--column align-center justify-center mx-0 mt-3">

      <div class="column is-9 flex--column align-center m-auto">

        <div class="chart__container" :style="chartContainerStyle">
          <div class="chart__bar" :style="firstBarStyle">
            <div class="chart__bar-label top" :style="barLabelStyle">
              {{ wall.what_should_be_paid | commasep(0) }}
            </div>
          </div>
          <div class="chart__bar" :style="secondBarStyle">
            <div 
              class="chart__bar-label" 
              :class="savings < 0 ? 'bottom' : 'top'" 
              :style="barLabelStyle">
              {{ savings | commasep(0) }}
            </div>
          </div>
          <div class="chart__bar" :style="thirdBarStyle">
            <div 
              class="chart__bar-label" 
              :class="addHeight == 0 ? 'bottom' : 'top'"
              :style="barLabelStyle">
              {{ -wall.elec_proceeds_for_business | commasep(0) }}
            </div>
          </div>
          <div class="chart__bar" :style="fourthBarStyle">
            <div 
              class="chart__bar-label top"
              :style="barLabelStyle">
              {{ wall.price - wall.elec_proceeds_for_business | commasep(0) }}
            </div>
          </div>

          <div class="baseline" :style="baselineStyle">
          </div>
        </div>

        <div 
          class="is-fullwidth flex flex--row mt-2 chart__label-wrapper" 
          :style="{width: `${chartWidth}px`}">
          <div class="chart__label">
            REGULAR <div>COST ($)</div>
          </div>
          <div class="chart__label">
            <span v-if="pricingType == 'dpa'">
              DPA <div>INVESTMENT ($)</div>
            </span>
            <span v-else>
              MPA <div>SAVINGS ($)</div>
            </span>
          </div>
          <div class="chart__label">
            <span class="is-size-tiny">APPROX. </span>ENERGY REVENUE ($)
            <div class="is-size-tiny">OVER 30 YEARS</div>
          </div>
          <div class="chart__label">
            NET <div>COST ($)</div>
            <div class="is-size-tiny">AFTER 30 YEARS</div>
          </div>
        </div>

        <div class="mt-3 chart__note has-text-centered">
          Note: The upfront cost of the Solar Wall portion of this project is CAD {{ wall.price | currency }}
        </div>

      </div>
    
    </div>

    <!-- <div class="columns mx-0 my-2">

      <div class="column is-5 mr-2">
        <header class="title is-size-5 has-text-weight-bold">
          Solar Cladding
        </header>
        <div class="subtitle is-size-6 has-text-weight-semibold">
          Solar Facing and Backing System
        </div>        
        <div v-html="value" class="is-size-6">
        </div>
      </div>

      <div class="column is-7">

        <div id="wall-price-chart">
        </div>

        <div
          class="columns is-multiline flex flex--row flex--justify-center">

          <div class="column px-0 is-12 flex flex--row flex--justify-space-between">
            <div class="flex flex--row flex--align-center mx-1">
              <div 
                class="icon price__icon is-medium">
                <img src="https://camas.app/resources/static/images/images/image__d1d2f17289b74ca86efce01bba005502.png"/>
              </div>
              <div>
                <div class="menu-label mb-0">
                  Cost Savings
                </div>
                <div>
                  CAD {{ wall.what_should_be_paid - wall.price | currency }}
                </div>
              </div>
            </div>
            <div class="flex flex--row flex--align-center mx-1">
              <div 
                class="icon price__icon is-medium">
                <img src="https://camas.app/resources/static/images/images/image__5ec394e06ff29b5daff480960abd832f.png"/>
              </div>
              <div>
                <div class="menu-label mb-0">
                  MITREX QUOTE
                </div>
                <div>
                  CAD {{ wall.price | currency }}
                </div>
              </div>
            </div>
          </div>
          
          <div class="column is-half flex flex--row flex--align-center">
            <div 
              class="icon price--total__icon is-medium">
              <i class="fas fa-credit-card"/>
            </div>
            <div>
              <div class="menu-label is-size-7 mb-0">
                What You Will Pay
              </div>
              <div>
                CAD {{ wall.price | currency(0) }}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div> -->

  </div>
</template>

<script>
import charts from '@/charts'
const d3 = Object.assign(
  {}, 
  require("d3-selection"), 
  require("d3-format")
);

export default {
  props: {
    value: {
      type: String
    },
    estimation: {
      type: Object
    },
    pricingType: {
      type: String,
      default: 'mpa'
    }
  },
  data() {
    return {
      chartHeight: 220,
      chartWidth: 400,
      barPadding: 15,
    }
  },
  computed: {
    wall({ estimation, pricingType }) {
      let summaryName = pricingType == 'dpa' ? 'estimation_summary_dpa' : 'estimation_summary';

      return estimation[summaryName].summary.filter(
        d => d.pricing_summary.includes('solar_wall')
      ).reduce((a, b) => {
        Object.keys(a).forEach(key => {
          a[key] = a[key] + +b[key]
        })
        return a
      }, { 
        elec_proceeds_for_business: 0, 
        elec_proceeds_for_mitrex: 0, 
        measure: 0, 
        price: 0, 
        what_should_be_paid: 0
      });
    },
    savings({ wall }) {
      return wall.price - wall.what_should_be_paid;
    },
    netPrice({ wall }) {
      return wall.price - wall.elec_proceeds_for_business;
    },
    addHeight({ netPrice }) {
      return netPrice < 0 ? Math.abs(netPrice) : 0;
    },
    barWidth({ chartWidth, barPadding }) {
      return chartWidth / 4 - barPadding * 2
    },
    chartContainerStyle({ chartHeight, chartWidth }) {
      return {
        position: 'relative',
        margin: 'auto',
        height: `${chartHeight}px`,
        width: `${chartWidth}px`,
      }
    },
    baselineStyle({ chartHeight, totalValue, addHeight }) {
      return {
        bottom: `${chartHeight * addHeight / totalValue}px`,
        left: '0px'
      }
    },
    totalValue({ wall, addHeight }) {
      return Math.max(wall.price, wall.what_should_be_paid) + addHeight;
    },
    firstBarStyle({ 
      wall, chartHeight, barWidth, barPadding, totalValue, addHeight
    }) {
      return {
        background: '#0E4E74',
        height: `${chartHeight * wall.what_should_be_paid / totalValue}px`,
        width: `${barWidth}px`,
        bottom: `${chartHeight * addHeight / totalValue}px`,
        left: `${barPadding}px`
      }
    },
    secondBarStyle({ savings, chartHeight, barWidth, barPadding, totalValue }) {
      return {
        background: '#E6ECF2',
        height: `${chartHeight * Math.abs(savings) / totalValue}px`,
        width: `${barWidth}px`,
        top: '0px',
        left: `${barPadding * 3 + barWidth}px`
      }
    },
    thirdBarStyle({ wall, chartHeight, barWidth, barPadding, secondBarStyle, totalValue, savings }) {
      return {
        background: '#F16635',
        height: `${chartHeight * wall.elec_proceeds_for_business / totalValue}px`,
        width: `${barWidth}px`,
        top: savings > 0 ? '0px' : secondBarStyle.height,
        left: `${barPadding * 5 + barWidth * 2}px`
      }
    },
    fourthBarStyle(
      { chartHeight, barWidth, barPadding, totalValue, netPrice }
    ) {
      return {
        background: '#0E4E74',
        height: `${chartHeight * Math.abs(netPrice) / totalValue}px`,
        width: `${barWidth}px`,
        bottom: '0px',
        left: `${barPadding * 7 + barWidth * 3}px`
      }
    },
    barLabelStyle({ barWidth }) {
      return {
        width: `${barWidth}px`
      }
    }
  },
  // mounted() {
  //   this.initializeCharts();
  // },
  methods: {
    initializeCharts() {
      let pieChart = charts.pie();

      const { wall } = this;

      let wallData = { 
        discount: +wall.what_should_be_paid - parseFloat(wall.price),
        price: +wall.price
      }

      d3.select("#wall-price-chart")
        .datum(wallData)
        .call(
          pieChart.color(d => d.data.key == 'discount' ? '#F16635' : '#E6ECF2')
            .strokeColor(d => d.data.key == 'discount' ? '' : '')
            .margin({ left: 5, right: 5, top: 5, bottom: 20 })
            .labels(true)
            .labelFn(d => 
              d3.format(".0%")(
                d.value / (wallData.discount + wallData.price)
              )
            )
            .labelColor(d => d.data.key == 'discount' ? '#fff' : '#0E4E74')
        );
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/flexbox.scss';
@import '@/styles/value-vs-price.scss';
</style>